import PropTypes from 'prop-types';
import React from 'react';
import { FormContext } from './form-context.js';

function FormProvider(props) {
  const { children, validationRules, errors = {}, disabled = false, readOnly = false } = props;

  return <FormContext.Provider value={{ validationRules, errors, disabled, readOnly }}>{children}</FormContext.Provider>;
}

FormProvider.propTypes = {
  children: PropTypes.node,
  validationRules: PropTypes.object.isRequired,
  errors: PropTypes.object,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
}

export default FormProvider
